import React, { useEffect, useState } from "react";
import micro_reporter_api from "../../apis/micro-reporter-api";
import deleteIcon from "../../assets/img/delete.png";
import {Button, Modal} from "react-bootstrap";
import Utils from "../../libraries/utils";

const ChartList = (props) => {

  const [chartList, setChartList] = useState();
  const [deleteReportVars, setDeleteReportVars] = useState({deleteValues: {reportName: "", reportId: "", relatedId: ""}});
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    getChartList();
  }, [props.returnChart])

  const getChartList = () => {
    (async () => {
      try{
        Utils.loadingScreen("show");
        let id = new URLSearchParams(window.location.search).get("reportId");
        await micro_reporter_api.get(`/micro-reporter/chart-detail/charts?reportId=` + id).then((response) => {
          setChartList(response.data);
          if(response.data && response.data.length > 0){
            document.querySelector('#chart-list').style.display = 'block';
          }else{
            document.querySelector('#chart-list').style.display = 'none';
          }
          Utils.loadingScreen("hide");
        })
      }catch (err){
          Utils.loadingScreen("hide");
      }
  	})();
  };

  const deleteReportDefinition = (id) => {
    (async () => {
        try{
            Utils.loadingScreen("show");
            let user = JSON.parse(localStorage.getItem("user"));
            let headers = {"userId": user.id, "username":user.username, "relatedName": encodeURIComponent(deleteReportVars.deleteValues.name), "relatedId": deleteReportVars.deleteValues.relatedId};
            const config = {headers};
            await micro_reporter_api.delete(`/micro-reporter/chart-detail/delete?id=${deleteReportVars.deleteValues.chartId}`, config);
            window.location.reload();
            Utils.loadingScreen("hide");
        }catch (err){
          Utils.loadingScreen("hide");
      }
    })();
  };

  const deleteChart = (item) =>{
    setDeleteReportVars({deleteValues: {name: item.name, chartId: item.id, relatedId: item.report.id}});
    setModalShow(true);
  };

  return (
    <div id="chart-list">
      <h5 className="page-title">Avaible Charts </h5>
      {
        chartList && chartList.length > 0 ?
          chartList.map(item => {
            return (
              <div id="chart-list-item"  key={item.id.toString()}>
                <div onClick={()=>{props.createChartButton(item)}} style={{ width: "100%", marginRight: "70px", padding: "12px 0px", cursor: "pointer" }}>
                  <span id="reportItemHeader">
                    {item.name}
                  </span>
                </div>
                  {
                      JSON.parse(localStorage.getItem('user')).role === "ADMIN" ?
                          <div className="report-wrapper">
                              <a className="chart-wrapper" onClick={()=>{deleteChart(item)}}>
                                  <img src={deleteIcon} alt="chart" className="compact-menu-report-dots" />
                              </a>
                          </div> : null
                  }
              </div>
            );
          }) : ''
      }
      <DeleteReportModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        delete={deleteReportDefinition}
        setDeleteReportVars={setDeleteReportVars}
      />
    </div>
  );
};

function DeleteReportModal(props){
  return (
      <Modal
          {...props}
          aria-labelledby="contained-modal-title-vcenter"
          centered
      >
          <Modal.Header closeButton>
              <Modal.Title id="contained-modal-title-vcenter">
                  <span id="connection-form-panel-title">Delete Chart</span>
              </Modal.Title>
          </Modal.Header>
          <Modal.Body>
              <div style={{padding: "5px 15px 5px "}}>Are you sure want to delete this chart?</div>
              <div></div>
          </Modal.Body>
          <Modal.Footer>
              <Button variant="light" onClick={props.delete}>Delete</Button>
              <Button variant="success" onClick={()=>{
                  props.setDeleteReportVars({deleteValues: {reportName: "", reportId: "", relatedId: ""}});
                  props.onHide();
              }}
              >
                  Cancel
              </Button>
          </Modal.Footer>
      </Modal>
  );
};
export default ChartList;
